<div class="container-error-503">
	<div class="box-container">
		<div class="box-header-container">
			<div class="box-header-title">
				<div class="box-header">
					<div class="text">
						{{ 'page503.title' | translate:ts.GetLang}}
					</div>
					<div class="subtitle">
						{{ 'page503.subtitle' | translate:ts.GetLang}}
					</div>
				</div>
				<div class="box-footer">
					{{ 'page503.paragraph' | translate:ts.GetLang}}
				</div>
			</div>

		</div>
		<div class="box-buttons">
			<app-button-warehouse buttonClass="btn-md-secondary" label="Refresh" (click)="goBack()">
			</app-button-warehouse>
			<app-button-warehouse label="Salir e intentar iniciar sesion" buttonClass="btn-md-primary" (click)="tryToLogin()">
			</app-button-warehouse>
		</div>
	</div>
</div>
